var styles = {"fontElementMap":"LKFcI","orderedlist":"KjjU2","bulletedlist":"_28NaN","listItem":"_20rRF"};

export { styles as s };
//# sourceMappingURL=lists-791021fb.js.map
